import { render, staticRenderFns } from "./QuestionType3.vue?vue&type=template&id=7de5d119"
import script from "./QuestionType3.vue?vue&type=script&lang=js"
export * from "./QuestionType3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports